import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  CREATE_USER,
  DELETE_USER,
  GET_USERS,
  UPDATE_USER_AVAILABILITY,
} from "URLRoutes";
import { generateURLOptions } from "URLOptions";
import UsersItem from "./UsersItem";
import Swal from "sweetalert2";
import CommonTextField from "components/common/CommonTextField";
import FilledButton from "components/InterstellrComponents/FilledButton";
import CreateUser from "./Modals/CreateUserModal";
import EditUser from "./Modals/EditUserModal";

const Users = () => {
  const [users, setUsers] = useState([]);
  const [addOpen, setAddOpen] = useState(false);

  const [editUser, setEditUser] = useState(null);
  const [editOpen, setEditOpen] = useState(false);

  const [search, setSearch] = useState("");

  useEffect(() => {
    document.title = "User Manager | Administration Panel | Mind Pulse";
    getUsers();
  }, []);

  useEffect(() => {
    getUsers();
  }, [search]);

  const getUsers = async () => {
    try {
      const response = await axios.get(
        GET_USERS + (search.length > 0 ? search : "all"),
        {
          headers: generateURLOptions(),
        }
      );
      if (response?.data?.success === false) {
        alert(response?.data?.message ?? "");
        return;
      }

      console.log("Users: ", response.data);
      setUsers(response?.data?.data);
    } catch (error) {
      console.error("Get Recipes Error: ", error);
      alert(error);
    }
  };

  const deleteUserItem = (id) => {
    Swal.fire({
      title: "Delete User",
      text: "Deleting a User is irreversible, User data is held onto for 90 days in accordance with local laws. Please confirm you want to delete this item.",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete User",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await axios
          .post(
            DELETE_USER,
            {
              itemId: id,
            },
            {
              headers: generateURLOptions(),
            }
          )
          .then(async (response) => {
            console.log(response);
            if (response?.data?.success == false) {
              return alert(response?.data?.message ?? "");
            }
            getUsers();
          })
          .catch((error) => {
            console.log("Delete Users Error: ", error);
            return alert(error);
          });
      }
    });
  };

  const updateUserAvailability = async (data) => {
    await axios
      .post(UPDATE_USER_AVAILABILITY, data, {
        headers: generateURLOptions(),
      })
      .then(async (response) => {
        console.log(response);
        if (response?.data?.success == false) {
          return alert(response?.data?.message ?? "");
        }
        getUsers();
      })
      .catch((error) => {
        console.log("Update User Status Error: ", error);
        return alert(error);
      });
  };

  const createUser = async (data) => {
    await axios
      .post(CREATE_USER, data, {
        headers: generateURLOptions(),
      })
      .then(async (response) => {
        console.log(response);
        if (response?.data?.success == false) {
          return alert(response?.data?.message ?? "");
        }
        setAddOpen(false);
        getUsers();
      })
      .catch((error) => {
        console.log("Create User Error: ", error);
        return alert(error);
      });
  };

  return (
    <>
      <CreateUser
        isOpen={addOpen}
        onClose={() => setAddOpen(false)}
        onSubmit={createUser}
      />

      <EditUser
        isOpen={editOpen}
        onClose={() => setEditOpen(false)}
        onSubmit={() => {}}
        profile={editUser}
      />

      <div className="w-full px-8">
        {/* Heading Area */}
        <div className="flex flex-row justify-center items-center mt-8">
          <div className="flex flex-col">
            <h4 className="font-medium text-lg">Users</h4>
            <p className="font-light text-base">{users?.length ?? 0} Users</p>
          </div>
          <div style={{ flex: 1 }} />
          <div className="w-1/3">
            <CommonTextField
              placeholder={"Search for a User"}
              type="text"
              marginBottom={0}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          <div className="w-1/6 ml-4">
            <FilledButton
              text={"Create User"}
              borderRadius={96}
              onPress={() => setAddOpen(true)}
            />
          </div>
        </div>

        {/* Render Users */}
        <div className="grid grid-cols-4 gap-2 mt-4">
          {users?.map((user) => (
            <UsersItem
              key={user?._id}
              item={user}
              onDelete={deleteUserItem}
              onChangeStatus={updateUserAvailability}
              onEdit={(data) => {
                setEditUser(data);
                setEditOpen(true);
              }}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default Users;
